// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/player." + chunkId + "." + {"127":"f956b4","141":"01cc68","184":"4a7385","274":"9d9280","389":"78b453","550":"b5e184","600":"b9aca0","615":"a38d23","664":"e6b1c5","719":"fb47f2","820":"1ceec7","949":"838ecb"}[chunkId] + ".js";
};